<template>
  <v-container>
    <v-row>
      <v-col>
        <policy-table
          :title="'API POLICY'"
          @newPolicyEvent="createPolicyEvent"
          @editPolicyEvent="updatePolicyEvent($event)"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  components: {
    PolicyTable: () => import('@/components/policy/PolicyTable')
  },
  methods: {
    createPolicyEvent() {
      this.$router.push('/policy-details/new');
    },
    updatePolicyEvent(item) {
      this.$router.push(`/policy-details/${item.policy_id}`);
    }
  }
};
</script>
